import { DataBean } from "../../DataBean";


export class TriageType extends DataBean {


    public async getTriageTypeCatalog(idState:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getTriageTypeCatalog_Number_String_Number_Number", [idState,regexStr,page,recordsPerPage]);
    }


}